
import moment from 'moment'
import { createDefaultShortcuts, MONTH_LIST } from '../util/shortcuts'

const BACK_BUTTON = {
  text: '返回',
  id: 'back'
  // onClick: picker => {
  //   picker.value = picker.oldValue
  //   picker.visible = false
  // }
}

export default {
  functional: true,
  render(h, context) {
    const {
      type = 'date',
      date: dateProp,
      shortcuts = [],
      disabledDate,
      clearable,
      showMonthSelect = false,
      changeShortcutMonth,
      handleShortcutClick,
      handleShortcutMonthClick,
    } = context.props
    let defaultShortcuts = createDefaultShortcuts(type)
    if (typeof disabledDate === 'function') {
      defaultShortcuts = defaultShortcuts.map(v => {
        let disabled = false
        if (typeof v.value === 'function') {
          const date = v.value()
          // disabledDate 时分秒永远是00:00:00
          const format = date => moment(moment(date).format('YYYY-MM-DD 00:00:00')).toDate()
          disabled = Array.isArray(date) ? date.some(d => disabledDate(format(d))) : disabledDate(format(date))
        }
        return {
          ...v,
          disabled
        }
      })
    }

    let _shortcuts = [...defaultShortcuts]

    // 自定义快捷方式
    if (Array.isArray(shortcuts) && shortcuts.length && shortcuts.every(v => typeof v === 'object')) {
      _shortcuts = shortcuts.map(v => v)
    }

    // 默认快捷方式筛选
    // 防止后续快捷方式变更，这里不应该把整个数组给到用户，应该给用户快捷方式标识，框架根据标识进行更新
    if (Array.isArray(shortcuts) && shortcuts.every(v => typeof v === 'string')) {
      _shortcuts = defaultShortcuts.filter(v => shortcuts.includes(v.id))
    }

    // 自定义快捷方式 + 默认快捷方式
    if (Array.isArray(shortcuts) && shortcuts.every(v => typeof v === 'string' || typeof v === 'object')) {
      _shortcuts = shortcuts.map(v => {
        return typeof v === 'string' ? _shortcuts.find(item => item.id === v) : v
      })
    }


    const showShortcuts = Array.isArray(_shortcuts) && _shortcuts.length > 0

    if (!showShortcuts) {
      return null
    }

    const shortcutsContent = () => {
      return _shortcuts.reduce((comps, item) => {
        const { text, disabled, id } = item || {}
        if (!clearable && id === 'clear') {
          return comps
        }
        const isDisabled = typeof disabled === 'function' ? disabled() : !!disabled
        const btnAttrs = {
          class: {
            'el-picker-panel__shortcut': true,
            'kye-date3-shortcut': true,
            'is-disabled': isDisabled
          },
          on: {
            click: () => {
              if (isDisabled) {
                return
              }
              handleShortcutClick(item)
            }
          }
        }
        comps.push(
          <button {...btnAttrs}>
            {{ text }}
          </button>
        )
        return comps
      }, [])
    }

    const monthContent = () => {
      let monthList = MONTH_LIST
      if (typeof disabledDate === 'function') {
        monthList = monthList.map(v => {
          let start = moment(dateProp).month(v.value - 1).startOf('month').startOf('day').toDate()
          let end = moment(dateProp).month(v.value - 1).endOf('month').endOf('day').toDate()
          let date = ['date', 'datetime'].includes(type) ? start : [start, end]
          return {
            ...v,
            disabled: Array.isArray(date) ? date.some(d => disabledDate(d)) : disabledDate(date)
          }
        })
      }
      return [BACK_BUTTON, ...monthList].reduce((comps, item) => {
        const { text, disabled } = item || {}
        const isDisabled = typeof disabled === 'function' ? disabled() : !!disabled
        const btnAttrs = {
          class: {
            'el-picker-panel__shortcut': true,
            'kye-date3-shortcut': true,
            'is-disabled': isDisabled
          },
          on: {
            click: () => {
              if (item.id === 'back') {
                changeShortcutMonth(false)
                return
              }
              if (isDisabled) {
                return
              }
              handleShortcutMonthClick(item)
            }
          }
        }
        comps.push(
          <button {...btnAttrs}>
            {{ text }}
          </button>
        )
        return comps
      }, [])
    }

    const content = showMonthSelect ? monthContent() : shortcutsContent()
    const shortcutsClass = {
      'kye-scrollbar': true,
      'el-picker-panel__sidebar': showShortcuts,
      'kye-date-picker3__shortcuts': showShortcuts,
      [type]: showShortcuts
    }
    return (
      <div class={shortcutsClass}>
        {
          content
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker3/src/basic/shortcuts-wrap.js